import { useEffect, useState } from 'react';
import { DEFAULT_CHAT_ID } from 'src/constants';
import { useThreadRegistry } from './threadHooks/useThreadRegistry';
import { useConversationParams } from './conversationHooks/useConversationParams';

/**
 * @deprecated
 */
export const useScrollToTask = () => {
  const { currentConversationId } = useConversationParams();

  const { isSubmitHappened } = useThreadRegistry();

  const [activeThreadAnchor, setActiveThreadAnchor] = useState<string | null>(
    null,
  );

  useEffect(() => {
    if (currentConversationId === DEFAULT_CHAT_ID) {
      setActiveThreadAnchor(null);
    }
  }, [currentConversationId]);

  useEffect(() => {
    if (isSubmitHappened) {
      setActiveThreadAnchor(null);
    }
  }, [isSubmitHappened]);

  return { activeThreadAnchor, setActiveThreadAnchor };
};
